import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "m4.313 10.002 2.61-3.868.553.372-2.61 3.87zm1.106.746 2.61-3.869.552.373-2.61 3.869zm1.105.746 2.61-3.87.553.374-2.61 3.868zm.553 8.64 2.61 3.868-.553.373-2.61-3.869zm-1.105.745 1.118 1.658-.553.373-1.118-1.658zm1.49 2.211 1.12 1.658-.554.373-1.118-1.658zm-2.596-1.465 2.61 3.869-.553.372-2.61-3.868zM25.077 6.134l1.118 1.658-.552.372-1.119-1.658zm1.491 2.21 1.118 1.658-.552.373-1.119-1.658zM23.972 6.88l2.61 3.869-.554.373-2.61-3.869zm-1.106.746 1.119 1.658-.553.373-1.118-1.658zm1.491 2.21 1.119 1.659-.553.372-1.118-1.658zm-2.043 14.166 1.118-1.658.553.373-1.119 1.658zm1.49-2.21 1.119-1.658.553.372-1.119 1.659zm-.385 2.956 1.118-1.658.553.373-1.118 1.658zm1.491-2.21 1.118-1.659.553.373-1.118 1.658zm-.386 2.956 1.119-1.658.552.372-1.118 1.658zm1.491-2.211 1.119-1.658.552.373-1.118 1.658z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M16 21.333a5.333 5.333 0 1 0 0-10.666 5.333 5.333 0 0 0 0 10.666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M21.333 16a5.333 5.333 0 0 1-10.666 0A2.667 2.667 0 0 0 16 16a2.667 2.667 0 1 1 5.333 0",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagKor = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagKor_default = SvgFlagKor;

export { FlagKor_default as default };
